class ConfiguratorAppointmentReview extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector("configurator-drawer");
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('button[type="submit"]');
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.possibleNextSteps = ["quality"];
    this.nextStepsHtml = {};
    this.previousStepHtml = undefined;
    this.getNextSteps();
    this.getPreviousSteps();

    this.insertUserName(this.drawer.appointment.personalInfo.firstName);
    this.insertLocationValues(this.drawer.appointment.location);
    this.insertDateTimeValues(
      this.drawer.appointment.date,
      this.drawer.appointment.time
    );
  }

  getFormValue() {
    const formData = new FormData(this.form);
    return [...formData.entries()];
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    const appointment = this.drawer.appointment;
    this.drawer.bundle.acuity = "appointment";
    this.drawer.bundle.appointment = {
      date: appointment.date,
      time: appointment.time,
      location: appointment.location,
      customerInfo: appointment.personalInfo,
    };

    this.renderNextStep("quality");
  }

  insertLocationValues(location) {
    const distanceValue = `${location.distance.toLocaleString("de-DE", {
      minimumFractionDigits: 1,
    })} km`;
    const locationElement = this.querySelector(
      ".drawer__form_option.scheduled.location"
    );
    locationElement.querySelector(".location_name").textContent = location.name;
    locationElement.querySelector(".location_street").textContent =
      location.street;
    locationElement.querySelector(".location_zip").textContent = location.zip;
    locationElement.querySelector(".location_city").textContent = location.city;
    locationElement.querySelector(".location_distance").textContent =
      distanceValue;
  }

  insertDateTimeValues(date, time) {
    const datetimeElement = this.querySelector(
      ".drawer__form_option.scheduled.datetime"
    );
    datetimeElement.querySelector(".datetime_date").textContent = date;
    datetimeElement.querySelector(".datetime_time").textContent = time;
  }

  insertUserName(userName) {
    const userNameWrapper = this.querySelector(".user_name");
    if (!userName || userName == "") userNameWrapper.remove();
    userNameWrapper.querySelector("span").textContent = userName.toUpperCase();
  }

  getNextSteps() {
    const sections = [];
    this.possibleNextSteps.forEach((step) =>
      sections.push("configurator-" + step)
    );
    const url = "?sections=" + sections.join(",");

    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        this.possibleNextSteps.forEach((step) => {
          this.nextStepsHtml[step] = response[`configurator-${step}`];
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getPreviousSteps() {
    fetch("?sections=configurator-appointment-personal-info")
      .then((response) => response.json())
      .then((response) => {
        this.previousStepHtml =
          response["configurator-appointment-personal-info"];
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderPreviousStep() {
    if (!this.previousStepHtml) return;

    this.drawer.renderContents(this.previousStepHtml);
  }

  renderNextStep(nextStep) {
    this.drawer.renderContents(this.nextStepsHtml[nextStep]);
  }
}

customElements.define(
  "configurator-appointment-review",
  ConfiguratorAppointmentReview
);
